module.exports = __webpack_public_path__ + "img/tip@2x.7380d0a4.png";